import { Contact } from '@shared/contact/models/contact';
import { MultiselectOption } from '@shared/multiselect/shared/types';

export class ContactOption extends Contact implements MultiselectOption {
  public getLabel(): string {
    return this.fullName;
  }
}
